<template>
  <div class="multi-select-wrapper">
    <MultiSelectDropDown
          :options="options"
          :selected="selectedBrands"
          @change="onChange($event)"
          @chosen="onChosen"
          label="Select"
          :placeholder="button"
        class="nav-item"
      >
      </MultiSelectDropDown>
  </div>
</template>

<script>

    import MultiSelectDropDown from "./MultiSelectDropDown";

    export default {
        name: "MultiSelectObject",
        components: {MultiSelectDropDown,},
        props: ["options", "button"],
        data() {
            return {
                brands: ["Yamaha", "Honda", "Suzuki", "Kawasaki", "Piaggio", "Aprilia", "BMW", "Peugeot", "KTM", "Ducati", "Cagiva", "Harley Davidson", "Polaris", "Vespa", "Hyosung", "Husaberg", "Husqvarna", "Daelim", "Moto Guzzi", "Triumph"],
                selectedBrands: []
            }
        },
        methods: {
            onChange(changed) {
                console.log("CHANGED", this.selectedBrands)
            },
            onChosen(chosen){
                this.$emit('chosen', chosen)
            }

        }

    }
</script>

<style scoped lang="scss">


.multi-select-wrapper{
    position: relative;
}

    .select-dropdown{
        margin-bottom: 10px;
    }

</style>
